module.exports = __webpack_public_path__ + "static/media/27.637cb048.jpg";